export default "__VITE_ASSET__72802f26__"